<template>
  <div class="messagebox">

  </div>
</template>
<script>

export default {
  name: "messagebox",
  data() {
    return {};
  },
  components: {

  },
  mounted() {},

  methods: {},

  watch: {},
};
</script>

<style lang="less" scoped>
.messagebox {

}
</style>


// WEBPACK FOOTER //
// src/components/user/tohome/messagebox.vue